module.exports = __webpack_public_path__ + "img/storyset-ui-ux-design-rafiki.a3702f8f.svg";